import { Image } from '@heroui/react';
import { Mail } from 'lucide-react';
import React, { FC } from 'react';

import NO_IMAGE from '../../assets/images/emptyImg.png';
import { HotelDocumentFirestoreResponse } from '../../types';
import { Flex, Stars } from '..';

interface HotelCardProps {
    data?: HotelDocumentFirestoreResponse | null;
}
export const HotelCard: FC<HotelCardProps> = ({ data }) => (
  <Flex
    justifyContent="center"
    itemAlign="center"
    direction="row"
    gap="20px"
  >
    <Image
      alt="HeroUI hero Image"
      radius="none"
      src={data?.brand_url || NO_IMAGE}
      width={150}
      height="auto"
    />
    <Flex direction="column" gap="10px">
      <h1 className="text-lg font-bold">{data?.name || 'Hotel name not found'}</h1>
      <Stars rating={data?.stars || 5} />
      <Flex justifyContent="flex-start" gap="5px">
        <p className="text-sm">{data?.address.city_name || 'City name not found |'}</p>
        <p className="text-sm">{data?.address.street || 'Address not found |'}</p>
        <p className="text-sm">{data?.address.number || 'Building number not found |'}</p>
        <p className="text-sm">{data?.address.postal_code || 'Postal code not found '}</p>
      </Flex>
      <Flex justifyContent="flex-start" gap="5px">
        <p className="text-sm flex items-center justify-center gap-1">
          <Mail size={16} color="gray" />
          {data?.email || 'No email'}
        </p>
      </Flex>
    </Flex>
  </Flex>
);
